import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { ProdutoViewPage } from '../produto-view/produto-view';
import { SemovelProvider } from '../../providers/semovel/semovel';


@Component({
  selector: 'page-produto-list',
  templateUrl: 'produto-list.html',
})
export class ProdutoListPage {  
  produtos: Array<any>;
  backup: Array<any>;

  grupo:any;

  infiniteScroll:any;

  nomeBusca = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, public eve:Events, public server: SemovelProvider) {
    this.grupo = navParams.get("grupo");
  }

  ionViewDidLoad() {
    this.produtos = [];
    console.log("outra busca load"); 
    this.buscarProdutos();
  }

  buscarProdutos( nome = null, tags = null){
    const request = { method: 'produto/list' };

    const filtroBusca:any = { };

    filtroBusca.tamanho = this.produtos.length;
    
    if(this.nomeBusca)
      filtroBusca.nome = this.nomeBusca;

    if(nome){
      filtroBusca.nome = nome;
    }

    if(this.grupo){
      filtroBusca.grupoId = this.grupo.id;
    }

    this.server.postData(request, filtroBusca, false).subscribe(data => {
      if(this.infiniteScroll){
        this.infiniteScroll.complete();
      }
      
      if (data && data.dados && data.dados.length){
        this.loadList(data.dados);
      }else{        
        if(this.infiniteScroll){
          this.infiniteScroll.enable(false);  
        }
      }
      return true;
    },
    error => {
      this.server.showError(error);          
    });
  }

  loadList(produtos) {
    let produto_server = produtos;
    for(var i in produto_server) {       
      let produto = produto_server[i];
      if(produto.imagem){
        produto.url_imagem = produto.imagem.url;//this.server.imagens+produto.imagem;      
      }
      // else{
      //   produto.url_imagem = this.server.imagens+"sem_imagem.jpg";      
      // }
      this.produtos.push(produto);
    }
  }
  
  //Eventos da Tela.   
  filtrarProdutos(ev: any) {
    if(this.infiniteScroll){
      this.infiniteScroll.enable(true);  
    }

    let val = ev.target.value;
    
    this.produtos = [];
    this.nomeBusca = val;
    this.buscarProdutos();
  }

  visualizarProduto(produto) {
    this.navCtrl.push(ProdutoViewPage, {
      produto: produto
    });
  }

  adicionarCarrinho(produto, unidade = undefined){
    this.eve.publish("carrinho:adicionar", produto, unidade);
  }

  carregarMais(infiniteScroll) {
    this.infiniteScroll = infiniteScroll;
    this.buscarProdutos();
    console.log("outra busca scroll");
  }

  avisar(produto, unidade){
    this.eve.publish("aviso:produto", produto, unidade);
  }
}



// WEBPACK FOOTER //
// ./src/pages/produto-list/produto-list.ts